<template>
    <div class="legend-list-wrapper">
        <ul class="legend-list">
            <li v-for="(data,index) in chartDataList" :key="index">
                <a href="#">
                    <p>
                        <span class="chart-chip" :style="{background: colorSet[index]}"></span>
                        <span class="text">{{data.name}} </span>
                    </p>
                    <p>{{data.count}}{{unit}}<em>{{data.score}}</em></p>
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name:'Report',
    props: {
        chartDataList: Array,
        unit: String,
        colorSet: Array
    }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/reports/cspReport.vue